const hasSlider = document.querySelector('.js-webmaster-tools__slider .swiper');

if (hasSlider) {
	Promise.all([
		import('swiper'),
		import(
			/* webpackExports: ["Navigation", "Pagination"] */
			'swiper/modules'
		),
	])
		.then(([{ default: Swiper }, { Navigation, Pagination }]) => {
			const swiper = new Swiper('.js-webmaster-tools__slider .swiper', {
				slidesPerView: 'auto',
				pagination: {
					el: '.js-webmaster-tools__slider .swiper-pagination',
				},
				navigation: {
					prevEl: '.js-webmaster-tools__slider-arrow-left',
					nextEl: '.js-webmaster-tools__slider-arrow-right',
				},
				modules: [Navigation, Pagination],
			});
		})
		.catch((err) => console.error(err));
}
